<template>
  <LazyItem @load="onShow">
    <div class="goods-chunk" :style="{ height }">
      <div v-for="(item, index) in list" :key="item.guid">
        <slot :goods="item" :index="index"></slot>
      </div>
      <div>
        <slot name="append"></slot>
      </div>
    </div>
  </LazyItem>
</template>

<script>
import * as heightComputer from "../HeightComputer/index";

export default {
  name: "GoodsChunk",
  props: {
    preview: Boolean,
    config: Object,
    data: Object,
    chunkType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: [],
      trueCount: -1
    };
  },
  methods: {
    onShow() {
      if (this.preview) return;
      this.getList();
    },
    async getList() {
      const result = await this.data.request(this.data.query);
      if (!result.success || !result.data) return;
      this.list = result.data.list || result.data;
      this.trueCount = this.list.length;
      if (this.trueCount === this.data.length) result;
      this.$emit("length-change");
    }
  },
  computed: {
    height() {
      if (!heightComputer[this.chunkType]) return 0;
      const count = this.trueCount === -1 ? this.data.length : this.trueCount;
      return (
        heightComputer[this.chunkType]({ count, config: this.config }) + "px"
      );
    }
  },
  watch: {
    "data.query": {
      handler(now) {
        if (!this.preview) return;
        this.getList();
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.goods-chunk {
  /*background-color: orangered;*/
}
</style>
